import { render, staticRenderFns } from "./health-data-component.vue?vue&type=template&id=263a3b75&scoped=true&lang=pug"
import script from "./health-data-component.js?vue&type=script&lang=js&external"
export * from "./health-data-component.js?vue&type=script&lang=js&external"
import style0 from "./health-data-component.vue?vue&type=style&index=0&id=263a3b75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263a3b75",
  null
  
)

export default component.exports